export default "__VITE_ASSET__D16oL4fF__"